export default {
  "content": "<path d=\"M16.4 15.6c-.3.7-.7 1.3-1.1 1.9-.6.8-1 1.4-1.4 1.7-.6.5-1.1.8-1.8.8-.5 0-1-.1-1.6-.4-.6-.3-1.2-.4-1.8-.4-.6 0-1.2.1-1.8.4-.7.2-1.2.4-1.6.4-.6 0-1.2-.2-1.8-.8-.4-.3-.9-.9-1.4-1.7-.6-.9-1.1-1.9-1.5-3C.2 13.3 0 12 0 10.9c0-1.3.3-2.5.9-3.5C1.4 6.6 2 6 2.7 5.6c.6-.6 1.4-.8 2.3-.8.5 0 1.1.1 1.9.4.8.3 1.3.4 1.5.4.2 0 .7-.2 1.7-.5.9-.3 1.7-.5 2.3-.4 1.7.1 2.9.8 3.8 2-1.5.9-2.2 2.2-2.2 3.8 0 1.3.5 2.3 1.4 3.2.4.4.9.7 1.4.9-.2.4-.3.7-.4 1zM12.5.4c0 1-.4 1.9-1.1 2.8-.9 1-1.9 1.6-3.1 1.5v-.4c0-1 .4-2 1.2-2.8.4-.4.8-.8 1.4-1.1.5-.2 1.1-.4 1.6-.4v.4z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "17",
    "height": "20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};